import Status               from "dashboard/dist/Core/Status";
import DateTime             from "dashboard/dist/Utils/DateTime";
import Utils                from "dashboard/dist/Utils/Utils";

// Types
import {
    LOCATION_LOADING, LOCATION_CHARGING,
    LOCATION_LIST, LOCATION_ELEM, LOCATION_CREATE,
} from "Utils/Types";



// The initial State
const initialState = {
    loading   : false,
    charging  : false,
    error     : false,
    edition   : 0,
    canCreate : false,
    canEdit   : false,
    canImport : false,
    canExport : false,
    list      : [],
    total     : 0,
    elem      : {},
    countries : [],
    provinces : {},
    sort      : {
        orderBy  : "name",
        orderAsc : 1,
        page     : 0,
        amount   : 50,
    },
};



/**
 * Parses the List
 * @param {Object[]} list
 * @returns {Object[]}
 */
function parseList(list) {
    return Utils.parseList(list, parseElem);
}

/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.createdDate     = DateTime.formatDate(elem.createdTime, "dashes");
    elem.createdDateTime = DateTime.formatDate(elem.createdTime, "dashesTime");
    elem.statusName      = Status.getName(elem.status);
    elem.statusColor     = Status.getColor(elem.status);
    elem.statusClass     = Status.getTextClass(elem.status);
    return elem;
}



/**
 * The Actions
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, LOCATION_LIST, LOCATION_ELEM, LOCATION_CREATE)) {
        return { ...state, loading : false, charging : false, error : true };
    }

    switch (action.type) {
    case LOCATION_LOADING:
        return {
            ...state,
            loading   : true,
        };
    case LOCATION_CHARGING:
        return {
            ...state,
            charging  : true,
        };

    case LOCATION_LIST:
        return {
            ...state,
            loading   : false,
            error     : false,
            canCreate : action.data.canCreate,
            canEdit   : action.data.canEdit,
            canImport : action.data.canImport,
            canExport : action.data.canExport,
            list      : parseList(action.data.list),
            total     : action.data.total,
            sort      : action.data.sort,
        };

    case LOCATION_ELEM:
        return {
            ...state,
            charging  : false,
            error     : false,
            edition   : state.edition + 1,
            canEdit   : action.data.canEdit,
            elem      : parseElem(action.data.elem),
            countries : action.data.countries,
            provinces : action.data.provinces,
        };

    case LOCATION_CREATE:
        return {
            ...state,
            error     : false,
            edition   : state.edition + 1,
            countries : action.data.countries,
            provinces : action.data.provinces,
        };

    default:
        return state;
    }
};

export default reducer;
